<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>

<div *ngIf="!accessdenied" class="row">
    <div *ngIf="isError" class="col-xl-12 block-style">
        <div class="alert alert-danger" role="alert">
            {{errorMessage}}
        </div>
    </div>
    <div *ngIf="!isError" class="col-xl-8" style="padding-right: 15px;padding-left:0px">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left"># {{sdrObj.Name}}</span>
                <span style="float:right">{{sdrObj.LastModifiedDate | date : 'medium'}}</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="container">
                <div class="row t30-padding">
                    <div class="col-md-12 col-sm-12 no-padding">
                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-left: 5px;padding-bottom: 10px;">
                            <small>
                                <span *ngIf="sdrObj.Status__c == 'Confirmation to Start the Work'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">{{sdrObj.Status__c}}</span>
                                <span *ngIf="sdrObj.Status__c == 'Completion Confirmation'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">{{sdrObj.Status__c}}</span>
                                <span *ngIf="sdrObj.Status__c == 'New'" style="background-color: blue; padding: 3px; border-radius: 5px; color: white;">{{sdrObj.Status__c}}</span>
                                <span *ngIf="sdrObj.Status__c == 'In Progress'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">{{sdrObj.Status__c}}</span>
                                <span *ngIf="sdrObj.Status__c == 'Planned'" style="background-color: orange; padding: 3px; border-radius: 5px; color: white;">{{sdrObj.Status__c}}</span>
                                <span *ngIf="sdrObj.Status__c != 'Confirmation to Start the Work' && sdrObj.Status__c != 'Completion Confirmation' && sdrObj.Status__c != 'New' && sdrObj.Status__c != 'In Progress' && sdrObj.Status__c != 'Planned'" style="background-color: grey; padding: 3px; border-radius: 5px; color: white;">{{sdrObj.Status__c}}</span>
                            </small>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-top:10px">
                            <pre style="background-color: white" [innerHTML]="sdrObj.Work_Order_Description__c"></pre>
                        </div>

                        <!--initial approval-->
                        <div *ngIf="sdrObj.Status__c === 'Confirmation to Start the Work' && !sdrObj.Customer_Approved__c" class="col-md-12 no-padding" style="margin-bottom:25px;box-shadow: 10px 10px 5px grey; border: 1px solid #00a6b6; background-color: white; padding: 10px !important; border-radius: 5px;">
                            <div class="col-md-12 ">
                                <p style="margin:0px;">Service Delivery Request has been reviewed by our team.<p>
                                <p style="margin:0px;">Please confirm the provided estimation to start the work ? </p>
                            </div>
                            <div class="col-md-12 no-padding" style="padding:8px;padding-top:10px !important;">
                                <textarea placeholder="type your comment here..." style="width:100%"></textarea>
                            </div>
                            <div class="col-md-12 ">
                                <div class="row">
                                    <div class="col-md-12 no-padding text-right">
                                        <button (click)="sendInitialApproval(true)" [disabled]="initialApprovalObj.btnDisabled" style="float: right;margin-right:5px;margin-left:5px" class="btn mygistec-main-btn">Confirm</button>
                                        <button (click)="sendInitialApproval(false)" [disabled]="initialApprovalObj.btnDisabled" class="btn btn-danger right" style="height:47px;margin-right: 5px; margin-left: 5px;float:right;">DON'T CONFIRM</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--final approval-->
                        <div *ngIf="sdrObj.Status__c === 'Completion Confirmation' && isAllSubTasksCompleted && !sdrObj.Final_Customer_Approval__c" class="col-md-12 no-padding" style="margin-bottom:25px;box-shadow: 10px 10px 5px grey; border: 1px solid #00a6b6; background-color: white; padding: 10px !important; border-radius: 5px;">
                            <div class="col-md-12 ">
                                <p style="margin:0px;">Service Delivery Request has been delivered by our team.<p>
                                <p style="margin:0px;">Please confirm the completion of the work ? </p>
                            </div>
                            <div class="col-md-12 no-padding" style="padding:8px;padding-top:10px !important;">
                                <textarea placeholder="type your comment here..." style="width:100%"></textarea>
                            </div>
                            <div class="col-md-12 ">
                                <div class="row">
                                    <div class="col-md-12 no-padding text-right">
                                        <button (click)="sendFinalApproval(true)" [disabled]="finalApprovalObj.btnDisabled" style="float: right;margin-right:5px;margin-left:5px" class="btn mygistec-main-btn">Confirm</button>
                                        <button (click)="sendFinalApproval(false)" [disabled]="finalApprovalObj.btnDisabled" class="btn btn-danger right" style="height: 47px; margin-right: 5px; margin-left: 5px; float: right;">DON'T CONFIRM</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12  no-padding">
                            <div class="row" style="padding-bottom: 10px; padding-top: 10px">
                                <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px;">
                                    <b>Attachments</b>
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-6" *ngFor="let item of SDRAttachments">
                                    <div class="file-body" style="padding-bottom: 5px">
                                        <i style="font-size: 18px !important;">
                                            <span class="fa fa-file"></span>
                                            <a style="    padding-left: 10px;cursor: pointer; font-size: 15px !important;"
                                               (click)="downloadAttachment(item.href,item.Name)">{{item.Name}}</a>
                                        </i>
                                    </div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="SDRAttachments.length == 0">
                                    No attachment(s) found
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top:20px">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Activities</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;padding:0px">
            <div class="container">
                <div class="row">

                    <mat-tab-group>
                        <mat-tab label="REPLIES">
                            <div class="row" style="margin-top:10px;padding:15px">
                                <div class="col-xl-12 no-padding">
                                    <div class="col-md-12 col-sm-12 no-padding">
                                        <div class="col-md-12 col-sm-12 col-xs-12  no-padding">
                                            <mat-accordion class="example-headers-align">
                                                <mat-expansion-panel style="margin-bottom:10px;" *ngFor="let item of SDRActivityLog; let i = index">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title>
                                                            <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                                                <span>{{i + 1}}: </span>
                                                                <img style="width:30px;border-radius:50%" class="message-avatar" src="{{item.OwnerImg}}" alt="">
                                                                <a style="padding-left:5px; font-size:14px;color:#252525"> {{item.OwnerName}} </a>
                                                                <small style="float: right; opacity:.5"> {{item.CreatedDate | date:'medium'}} </small>
                                                            </div>

                                                        </mat-panel-title>
                                                    </mat-expansion-panel-header>

                                                    <pre style="background-color: transparent;font-size:14px !important; color:#252525" [innerHTML]="item.Description"></pre>

                                                </mat-expansion-panel>

                                            </mat-accordion>
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                            <textarea placeholder="Write your message here..." style="padding:10px !important;    font-size: 14px !important; margin-bottom: 10px;   border-color: lightgrey;border-bottom: 2px solid #00A6B6;width:100%;height:100px" class="summernote" [(ngModel)]="activityHistory.Description"></textarea>


                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <div clas="col-md-3" style="padding-top:15px ">
                                                        <div class="form-row">
                                                            <input type="file" (change)="filesSelect($event)" name="file" id="file" class="inputfile" />
                                                            <label for="file">Attachments <i class="far fa-file"></i></label>
                                                        </div>
                                                    </div>
                                                    <table class="table" *ngIf="files.length > 0">
                                                        <thead>
                                                            <tr>
                                                                <th width="50%">Name</th>
                                                                <!--<th>Size</th>-->
                                                                <th>Remove</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let item of files;let i = index">
                                                                <td><strong>{{ item.name }}</strong></td>
                                                                <!--<td  nowrap>{{ item.size/1024/1024|number:2 }} MB</td>-->
                                                                <td nowrap>
                                                                    <a style="cursor:pointer" (click)="removeFile(i)">
                                                                        <span class="fa fa-trash"></span> Remove
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>




                                            <div class="col-md-12" style="padding-top:5px; text-align: right; ">
                                                <button style="float:right" [disabled]="btnSendDisabled" (click)="sendActivityHistory()" class="btn mygistec-main-btn">{{btnSend}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </mat-tab>

                        <mat-tab label="TASKS">
                            <div class="row" style="margin-top:10px;padding:15px">
                                <div class="col-xl-12 no-padding">
                                    <div class="col-md-12 col-sm-12 no-padding">
                                        <div *ngIf="SDRSubTasks.length == 0" class="col-xl-12 no-padding  text-center" style="margin-top:25px">
                                            No tasks found
                                        </div>
                                        <mat-accordion class="example-headers-align" [multi]="true">
                                            <mat-expansion-panel [expanded]="false" style="margin-bottom:10px;" *ngFor="let task of SDRSubTasks;let i = index">
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                                            <a style="padding-left:5px; font-size:14px;color:#252525">{{i+1}}: {{task.Name}} </a>
                                                            <small style="opacity:.5; float: right"> {{task.Status__c}} </small>
                                                        </div>

                                                    </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <div class="row">
                                                    <div *ngIf="task.Resources__r" class="col-xl-12  no-padding">
                                                        <div class="row">
                                                            <div class="col-xl-12 " style="padding-left: 20px; padding-right: 20px; padding-top: 30px">
                                                                
                                                                <b>Estimation Work</b>
                                                            </div>
                                                            <div class="col-xl-12 ">
                                                                <table style="font-size: 12px!important;" cellpadding="1" cellspacing="1" class="table table-bordered table-striped">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Employee</th>
                                                                            <th>Start Date</th>
                                                                            <th>End Date</th>
                                                                            <th>Man Days</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr *ngFor="let x of task.Resources__r.records">
                                                                            <td><span *ngIf="x.Proposed_Employee__r">{{ x.Proposed_Employee__r.Name }}</span></td>
                                                                            <td><span *ngIf="x.Estimated_Start_Date__c">{{ x.Estimated_Start_Date__c | date:'medium'}}</span></td>
                                                                            <td><span *ngIf="x.Estimated_End_Date__c">{{ x.Estimated_End_Date__c | date:'medium'}}</span></td>
                                                                            <td><span *ngIf="x.Estimated_Man_Days__c">{{ x.Estimated_Man_Days__c }}</span></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colspan="3"><b style="float:right">Total Man-Days</b></td>
                                                                            <td><b><span *ngIf="task.Man_Days_Estimated__c">{{ task.Man_Days_Estimated__c}}</span></b></td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div class="col-xl-12 " style="padding-left:20px; padding-right:20px; padding-top:30px">
                                                                <b>Actual Work</b>
                                                            </div>
                                                            <div class="col-xl-12">
                                                                <table style="font-size: 12px!important;" cellpadding="1" cellspacing="1" class="table table-bordered table-striped">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Employee</th>
                                                                            <th>Start Date</th>
                                                                            <th>End Date</th>
                                                                            <th>ManDays</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr *ngFor="let x of task.Resources__r.records">
                                                                            <td><span *ngIf="x.Employee__r">{{ x.Employee__r.Name }}</span></td>
                                                                            <td><span *ngIf="x.Start_Date__c">{{ x.Start_Date__c | date:'medium'}}</span></td>
                                                                            <td><span *ngIf="x.End_Date__c">{{ x.End_Date__c | date:'medium'}}</span></td>
                                                                            <td><span *ngIf="x.Actual_Man_Days__c">{{ x.Actual_Man_Days__c }}</span></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colspan="3"><b style="float:right">Total Man-Days</b></td>
                                                                            <td><b><span *ngIf=" task.Real_Man_Days__c">{{ task.Real_Man_Days__c}}</span></b></td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </mat-expansion-panel>

                                        </mat-accordion>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>


                    </mat-tab-group>



                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!isError" class="col-xl-4">
        <!--finally approved-->
        <div *ngIf="sdrObj.Final_Customer_Approval__c" class="row" style="margin-bottom:15px !important">

            <div class="col-xl-12 block-style" style="border: 1px solid #17a2b8;">
                <div class="row align-items-center">
                    <div class="">
                        <mat-checkbox [(ngModel)]="sdrObj.Final_Customer_Approval__c" disabled>Completion Confirmed</mat-checkbox>
                    </div>
                </div>
                <div class="row small-section-content" style="margin-top:10px">
                    <p>{{ sdrObj.Customer_Commnet_final__c}}</p>

                </div>
            </div>

        </div>
        <!--initially approved-->
        <div *ngIf="sdrObj.Customer_Approved__c" class="row" style="margin-bottom:15px !important">

            <div class="col-xl-12 block-style" style="border: 1px solid #17a2b8;">
                <div class="row align-items-center">
                    <div class="">
                        <mat-checkbox disabled [(ngModel)]="sdrObj.Customer_Approved__c">Start Work Confirmed</mat-checkbox>
                    </div>
                </div>
                <div class="row small-section-content" style="margin-top:10px">
                    <p>
                        {{sdrObj.Customer_Comment__c}}
                    </p>
                </div>
            </div>
        </div>
        <!--carbon copy-->
        <app-follower-box [title]="'Share service delivery request'" [relatedTo]="'services'" [relatedId]="id"></app-follower-box>

        <!--Request details-->
        <div class="row" style="margin-bottom:15px !important">
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Request details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div class="row small-section-content">
                    <div class="col-xl-12 no-padding" style="margin-top:0px">
                        <div style="font-weight: bold;">Requester name</div>
                        <div style="margin-top:10px">
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd;">{{sdrObj.Contact__r.Name}}</span>
                        </div>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Requester account</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.Client__r.Name}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Request origin</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.Origin__c}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Created date</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.CreatedDate | date: 'medium'}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Last modified date</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.LastModifiedDate | date: 'medium'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!--service delivery request details-->
        <div class="row" style="margin-bottom:15px !important">
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Service delivery request details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div class="row small-section-content">
                    <div class="col-xl-12 no-padding" style="margin-top:0px">
                        <div style="font-weight: bold;">Type</div>
                        <div style="margin-top:10px">
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd;">{{sdrObj.Type__c}}</span>
                        </div>
                    </div>
                    <div *ngIf="sdrObj.SDR_Responsible__r" class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Responsible by</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.SDR_Responsible__r.Name}}</p>
                    </div>
                    <div *ngIf="sdrObj.Start_Date__c" class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Start date</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.Start_Date__c | date : 'medium'}}</p>
                    </div>
                    <div *ngIf="sdrObj.End_Date__c" class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">End date</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.End_Date__c | date : 'medium'}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Consumed credits</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{sdrObj.Consumed_Man_Days__c}}</p>
                    </div>
                </div>
            </div>
        </div>


    </div>

</div>
